{
  "version": "1.2.6",
  "objects": {
    "7431911414818200041": {
      "type": "frame",
      "id": "7431911414818200041",
      "z": 7256,
      "textContent": "",
      "left": 4040.8528306907856,
      "top": 303.4643593376329,
      "width": 400,
      "height": 500,
      "scaleX": 1.1222836980167403,
      "scaleY": 0.3,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "top"
    },
    "7431911499089813758": {
      "type": "frame",
      "id": "7431911499089813758",
      "z": -260,
      "textContent": "Frame 143",
      "left": 4070.8528306907856,
      "top": 393.4643593376329,
      "width": 400,
      "height": 500,
      "scaleX": 0.9722836980167403,
      "scaleY": 0.06,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7431911414818200041",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7431911499098706516": {
      "type": "wireframe",
      "id": "7431911499098706516",
      "z": 2148,
      "top": 393.4643593376329,
      "left": 4070.8528306907856,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7431911499089813758",
      "layoutPosition": "a0",
      "wireframeName": "dropdown",
      "fill": "#CACACA",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Sort by: Most popular",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      }
    },
    "7431911499085288474": {
      "type": "wireframe",
      "id": "7431911499085288474",
      "z": 4296,
      "top": 393.4643593376329,
      "left": 4277.766309897482,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7431911499089813758",
      "layoutPosition": "a1",
      "wireframeName": "dropdown",
      "fill": "#CACACA",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Filter: Tags – Research",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      },
      "setDimension": false
    },
    "7431911414822929174": {
      "type": "wireframe",
      "id": "7431911414822929174",
      "z": 6626,
      "top": 333.4643593376329,
      "left": 4070.8528306907856,
      "width": 388.91347920669614,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414818200041",
      "layoutPosition": "a0",
      "wireframeName": "searchBar",
      "fill": "#CACACA",
      "itemsData": {
        "7429333925299645014": {
          "id": "7429333925299645014",
          "value": "Item",
          "item_position": 2000000
        },
        "7429333925306962229": {
          "id": "7429333925306962229",
          "value": "Item",
          "item_position": 0
        },
        "7429333925307777585": {
          "id": "7429333925307777585",
          "value": "Item",
          "item_position": 1000000
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Search",
        "iconLeft": { "prefix": "fas", "iconName": "magnifying-glass" }
      },
      "setDimension": true
    }
  }
}
